module.exports = __webpack_public_path__ + "static/img/xsms@2x.51faf076.png";